import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';
import HowWork from './components/HowWorks';
import NotFound from './components/NotFound';
import Header from './constants/Header';
import DeepLinkHandler from './components/DeepLinkHandler';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main route with all sections */}
        <Route path="/" element={<MainApp />} />
        
        {/* 404 fallback for any unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

function MainApp() {
  return (
    <div className="App">
      <DeepLinkHandler />
      <Header />
      <div id="home">
        <Home />
      </div>
      <div id="services">
        <HowWork />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  );
}

export default App;
